export default class {
  logout() {
    window.sessionStorage.removeItem('sessionId');
    window.sessionStorage.removeItem('userId');
    window.sessionStorage.removeItem('app.tabs');
    window.sessionStorage.removeItem('headIcon');
    window.sessionStorage.removeItem('realName');
    window.sessionStorage.removeItem('users');
    window.localStorage.removeItem('sessionId');
    window.localStorage.removeItem('userId');
    window.localStorage.removeItem('app.tabs');
    window.localStorage.removeItem('headIcon');
    window.localStorage.removeItem('realName');
    window.localStorage.removeItem('users');
    window.location.replace(window.location.href.split('/#/')[0] + '/login.html');
  }
}
